import { useRef } from "react";
import { ArtButton, ArtTable, ArtTableHandle, HeadCell, SSRTableBuilder, useApiService } from "@art/shared-ui";

export default function ArtRoleAssignDialog({ data, closeDialog, masterRoles }: any) {
    const tableRef = useRef<ArtTableHandle>(null);
    const apiService = useApiService();

    const selectedRoleIds = data?.roles?.map((x: any) => String(x.id)) ?? [];
    const selectedIds: [] = []

    interface Data {
        id: string;
        title: string;
        description: string;
    }

    const headCells: HeadCell<Data>[] = [
        {
            id: 'title',
            numeric: false,
            disablePadding: false,
            label: 'Role',
            getColData: (row: any) => row["title"],
        },
        {
            id: 'description',
            numeric: false,
            disablePadding: false,
            label: 'Description',
            getColData: (row: any) => row["description"],
        },
    ];

    const tableBuilder = SSRTableBuilder<Data>({
        endpoint: "/roles/list",
        apiService: apiService,
        method: "get",
         onFetch: (params) => {
            return {
                "page": params["page"],
                "search_text": params["search_text"]
            }
        },
        onResponse: (data: any) => {
            return {
                data: data.data.roles ?? [],
                total: masterRoles?.length ?? 0
            };
        }
    });

    const handleUpdateRoles = async (selected: string[]) => {
        const newAddedRoles = selected
            .filter((id: string) => !selectedRoleIds.includes(String(id)))
            .map((id: string) => {
                const role = masterRoles.find((r: any) => r.id === String(id));
                return role ? { id: String(role.id), title: role.title } : null;
            })
            .filter(Boolean);

            const removedRoles = selectedRoleIds
            .filter((id: string) => !selected.includes(String(id)))
            .map((id: string) => String(id)).filter(Boolean);

        try {
            const requests: Promise<any>[] = [];

            if (newAddedRoles.length > 0) {
                requests.push(
                    apiService.post(`/art-users/${data.id}/roles`, {
                        roles: newAddedRoles,
                    })
                );
                apiService.showSnack("Roles updated successfully", "success");

            }

            if (removedRoles.length > 0) {
                requests.push(
                    apiService.delete(`/art-users/${data.id}/roles`, {
                        data: { role_ids: removedRoles },
                    })
                );
            }

            await Promise.all(requests);
            closeDialog();
            tableRef.current?.refresh?.();
        } catch (error) {
            console.error("Error updating roles:", error);
        }
    };

    return (
        <ArtTable ref={tableRef} headCells={headCells}
            builder={tableBuilder}
            search={{ enabled: true, value: "" }}
            disablePagination={true}            
            bulkOperationActions={{
                selected: selectedRoleIds.length>0 ? selectedRoleIds:selectedIds,
                findDiff: (selected) => {
                    const newAddedIds = selected.filter((id: any) => !selectedRoleIds.includes(id));
                    const removedIds = selectedRoleIds.filter((id: any) => !selected.includes(id));
                    return {
                        added: newAddedIds.length,
                        removed: removedIds.length
                    }
                },
                actions: (selected) => {
                    const newAddedIds = selected.filter((id: any) => !selectedRoleIds.includes(id));
                    const removedIds = selectedRoleIds.filter((id: any) => !selected.includes(id));
                    if (newAddedIds.length === 0 && removedIds.length === 0) {
                        return [];
                    }
                    return [
                        <ArtButton dataQa="btn-update" label="Update" onClick={() => {
                            handleUpdateRoles(selected)
                        }} />
                    ]
                }
            }}
        />
    );
}